<template>
  <v-card>
    <v-divider></v-divider>
    <v-card-text v-if="!this.ids.queryOvrAgt">
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12>
            <message :messages="messages"></message>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.polType}}</v-subheader>
            <div class="title">{{ovrAgtForm.polType}}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.effDate}}</v-subheader>
            <div class="title">{{formatDate(ovrAgtForm.effDate)}}</div>
          </v-flex>
          <v-flex xs6 v-if="newOvrAgt">
            <v-autocomplete :label="labels.ovrInter" v-model="ovrAgtForm.ovrInter" :items="interList" item-text="label" item-value="value" data-vv-name="ovrInter" :data-vv-as="labels.ovrInter" :error-messages="errors.collect('ovrInter')" v-validate="'required'"></v-autocomplete>
            <!-- <v-text-field :label="labels.ovrInter" v-model="ovrAgtForm.ovrInter" :error-messages="errors.collect('ovrInter')" v-validate="'required|max:8'" data-vv-name="ovrInter" :data-vv-as="labels.ovrInter"></v-text-field> -->
          </v-flex>
          <v-flex xs6 v-else>
            <v-subheader class="queryLabel">{{labels.ovrInter}}</v-subheader>
            <div class="title">{{ovrAgtForm.ovrInter}}</div>
          </v-flex>
          <v-flex xs6>
            <v-checkbox :label="labels.protect" v-model="ovrAgtForm.protect" :error-messages="errors.collect('protect')" data-vv-name="protect" :data-vv-as="labels.protect" :disabled="ovrAgtForm.void_"></v-checkbox>
          </v-flex>
          <v-flex xs6>
            <v-select :items="interGrossNetList" v-model="ovrAgtForm.commGN" :label="labels.commGN" item-text="label" item-value="value" data-vv-name="commGN" :data-vv-as="labels.commGN" :error-messages="errors.collect('commGN')" :disabled="ovrAgtForm.void_"></v-select>
          </v-flex>
          <v-flex xs6>
            <v-text-field :label="labels.commPct" v-model="ovrAgtForm.commPct" :error-messages="errors.collect('commPct')" v-validate="'mask_decimal:3|mask_max_value:100'" data-vv-name="commPct" :data-vv-as="labels.commPct" :disabled="ovrAgtForm.void_"></v-text-field>
          </v-flex>
          <v-flex xs6 v-if="ovrAgtForm.void_">
            <v-checkbox :label="labels.void_" v-model="ovrAgtForm.void_" :error-messages="errors.collect('void_')" data-vv-name="void_" :data-vv-as="labels.void_" :disabled="ovrAgtForm.void_"></v-checkbox>
          </v-flex>
          <v-flex xs6 v-if="ovrAgtForm.void_">
            <v-text-field :label="labels.voidReason" v-model="ovrAgtForm.voidReason" :error-messages="errors.collect('voidReason')" v-validate="'required|max:200'" data-vv-name="voidReason" :data-vv-as="labels.voidReason"></v-text-field>
          </v-flex>
          <v-flex xs6 v-if="!newOvrAgt">
            <v-subheader class="queryLabel">{{labels.createdBy}}</v-subheader>
            <div class="title">{{createdBy}}</div>
          </v-flex>
          <v-flex xs6 v-if="!newOvrAgt">
            <v-subheader class="queryLabel">{{labels.createdDate}}</v-subheader>
            <div class="title">{{formatDate(createdDate)}}</div>
          </v-flex>
          <v-flex xs6 v-if="!newOvrAgt">
            <v-subheader class="queryLabel">{{labels.modifiedBy}}</v-subheader>
            <div class="title">{{modifiedBy}}</div>
          </v-flex>
          <v-flex xs6 v-if="!newOvrAgt">
            <v-subheader class="queryLabel">{{labels.modifiedDate}}</v-subheader>
            <div class="title">{{formatDate(modifiedDate)}}</div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-text v-else>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12>
            <message :messages="messages"></message>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{labels.polType}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div class="title">{{ovrAgtForm.polType}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{labels.effDate}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div class="title">{{formatDate(ovrAgtForm.effDate)}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{labels.ovrInter}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div class="title">{{ovrAgtForm.ovrInter}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{labels.protect}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div class="title">{{formatBoolean(ovrAgtForm.protect)}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{labels.commGN}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div class="title">{{ovrAgtForm.commGN}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{labels.commPct}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div class="title">{{ovrAgtForm.commPct}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{labels.void_}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div class="title">{{formatBoolean(ovrAgtForm.void_)}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{labels.voidReason}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div class="title">{{ovrAgtForm.voidReason}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{labels.createdBy}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div class="title">{{createdBy}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{labels.createdDate}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div class="title">{{formatDate(createdDate)}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{labels.modifiedBy}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div class="title">{{modifiedBy}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{labels.modifiedDate}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div class="title">{{formatDate(modifiedDate)}}</div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-flex xs12 v-if="!this.ids.queryOvrAgt">
      <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doSaveGeneral">
        {{ newOvrAgt ? 'Save Overriding Agent' : 'Update Overriding Agent' }}
        <v-icon right>{{newOvrAgt ? 'mdi-plus' : 'mdi-content-save'}}</v-icon>
      </v-btn>
    </v-flex>
  </v-card>
</template>

<script>

import { interGrossNet } from '@/const/underwriting'
import { expandURI } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
import MessageMixin from '@/mixins/message'
import { formatDisplayDate, formatDisplayDateTime3 } from '@/utils/date'

export default {
  data() {
    return {
      labels: {
        polType: 'Policy Type',
        effDate: 'Effective Date',
        ovrInter: 'Overriding Agent*',
        protect: 'Protect Commission',
        commGN: 'Gross or Net',
        commPct: 'Rate %',
        void_: 'Void',
        voidReason: 'Void Reason',
        createdBy: 'Created by',
        createdDate: 'Created Date',
        modifiedBy: 'Modified by',
        modifiedDate: 'Modified Date'
      },
      ovrAgtForm: {
        inter: null,
        polType: null,
        effDate: null,
        ovrInter: null,
        protect: false,
        commGN: 'G',
        commPct: 0,
        void_: null,
        voidReason: null
      },
      submitting: false,
      newOvrAgt: false,
      createdBy: undefined,
      createdDate: undefined,
      modifiedBy: undefined,
      modifiedDate: undefined,
      interList: []
    }
  },
  computed: {
    interGrossNetList() {
      let result = []
      Object.keys(interGrossNet).forEach(function(key) {
        const status = interGrossNet[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    }
  },
  watch: {
    'ids.ovrInter': function (value) {
      this.doInit(value)
      this.resetMessages()
      this.resetValidator()
      this.doClearForm()
    }
  },
  methods: {
    async doInit(value) {
      const apiURI = this.$store.state.adminInter.intermediary.menu.getCommission
      if (apiURI) {
        try {
          const expand = {
            inter: this.ids.inter,
            effDate: formatDisplayDateTime3(this.ids.effDate),
            polType: this.ids.polType
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.menu = extractMenu(result.data._links)
          } else {
            this.errorMessage('Fail to load Data from server. Please try to refresh page')
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }

      await this.getInterList()
      if (value !== 'new') {
        this.newOvrAgt = false
        if (value !== null) {
          this.fetchForm(value)
        }
      } else {
        this.newOvrAgt = true
      }
    },
    async fetchForm(ovrInter) {
      if (!this.newOvrAgt) {
        this.ovrAgtForm.inter = this.ids.inter
        this.ovrAgtForm.effDate = this.ids.effDate
        this.ovrAgtForm.polType = this.ids.polType
        this.ovrAgtForm.ovrInter = this.ids.ovrInter

        const apiURI = this.menu.getOvrAgt
        if (apiURI) {
          try {
            const expand = {
              inter: this.ids.inter,
              effDate: formatDisplayDateTime3(this.ids.effDate),
              polType: this.ids.polType,
              ovrInter: this.ids.ovrInter
            }
            const result = await this.$http.get(expandURI(apiURI, expand))
            const { data } = result.data
            if (data) {
              this.ovrAgtForm.inter = data.ovrAgt.inter
              this.ovrAgtForm.polType = data.ovrAgt.polType
              this.ovrAgtForm.effDate = data.ovrAgt.effDate
              this.ovrAgtForm.ovrInter = data.ovrAgt.ovrInter
              this.ovrAgtForm.protect = data.ovrAgt.protect
              if (data.ovrAgt.commGn === 'Gross') {
                this.ovrAgtForm.commGN = 'G'
              } else if (data.ovrAgt.commGn === 'Net') {
                this.ovrAgtForm.commGN = 'N'
              }
              // this.ovrAgtForm.commGN = data.ovrAgt.commGn
              this.ovrAgtForm.commPct = data.ovrAgt.commPct
              this.ovrAgtForm.void_ = data.ovrAgt.void_
              this.ovrAgtForm.voidReason = data.ovrAgt.voidReason
              this.createdDate = data.ovrAgt.createdDate
              this.modifiedDate = data.ovrAgt.modifiedDate

              this.createdBy = data.strCreatedBy
              this.modifiedBy = data.strModifiedBy

              // this.menu = extractMenu(result.data._links)
            } else {
              this.errorMessage('Fail to load Data from server. Please try to refresh page')
            }
          } catch (error) {
            const { data } = error.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          }
        } else {
          this.errorMessage('The request failed because it is trying to execute an invalid API url. - Overriding Agent Form')
        }
      }
    },
    async doSaveGeneral() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newOvrAgt) {
            this.doCreateGeneral()
          } else {
            this.doUpdateGeneral()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreateGeneral() {
      try {
        const apiURI = this.menu.createOvrAgt
        if (apiURI) {
          const formatForm = {
            inter: this.ovrAgtForm.inter,
            polType: this.ovrAgtForm.polType,
            effDate: this.ovrAgtForm.effDate,
            ovrInter: this.ovrAgtForm.ovrInter,
            protect: this.ovrAgtForm.protect,
            commGN: this.ovrAgtForm.commGN,
            commPct: parseFloat(this.ovrAgtForm.commPct)
          }
          const result = await this.$http.post(apiURI, formatForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$emit('resetTab', 2)
          }
        }
      } catch (error) {
        const { data } = error.response
        if (data) {
          this.message(data)
          this.fieldMessage(data)
        }
      }
    },
    async doUpdateGeneral() {
      const apiURI = this.menu.updateOvrAgt
      if (apiURI) {
        try {
          const formatForm = {
            inter: this.ovrAgtForm.inter,
            polType: this.ovrAgtForm.polType,
            effDate: this.ovrAgtForm.effDate,
            ovrInter: this.ovrAgtForm.ovrInter,
            protect: this.ovrAgtForm.protect,
            commGN: this.ovrAgtForm.commGN,
            commPct: parseFloat(this.ovrAgtForm.commPct),
            voidReason: this.ovrAgtForm.voidReason
          }
          const result = await this.$http.put(apiURI, formatForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$emit('resetTab', 2)
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url. - Overriding Agent Update')
      }
    },
    async getInterList() {
      const apiURI = this.menu.interList
      try {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        if (data) {
          this.interList = data
        }
      } catch (err) {
        throw err
      }
    },
    formatDate(xDate) {
      if (xDate === null) {
        return undefined
      } else {
        return formatDisplayDate(xDate)
      }
    },
    formatBoolean(bool) {
      if (bool) {
        return 'Yes'
      } else {
        return 'No'
      }
    },
    doClearForm() {
      this.resetValidator()
      this.resetMessages()
      this.ovrAgtForm.inter = this.ids.inter
      this.ovrAgtForm.polType = this.ids.polType
      this.ovrAgtForm.effDate = this.ids.effDate
      this.ovrAgtForm.ovrInter = null
      this.ovrAgtForm.protect = false
      this.ovrAgtForm.commGN = 'G'
      this.ovrAgtForm.commPct = 0
      this.ovrAgtForm.void_ = null
      this.ovrAgtForm.voidReason = null
    }
  },
  mixins: [
    MessageMixin
  ],
  props: {
    ids: {
      type: Object,
      default () {
        return {
          inter: null,
          commissionNo: null,
          effDate: null,
          polType: null,
          ovrInter: null,
          queryOvrAgt: null
        }
      }
    }
  }
}
</script>

<style>
</style>
